import React from 'react';
import { connect } from 'react-redux';
import { logout } from '../../store/actions/userActions';

// @material-ui/icons
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import TurnedInNotIcon from '@material-ui/icons/TurnedInNot';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import Auth from 'services/AuthService';

const Settings = ({ logout, history }) => {
  const signout = async () => {
    try {
      await Auth.logout();
      logout();
    } catch (error) {
      // TODO: error handling
      console.log(error);
    }
  };

  return (
    <Card
      style={{
        height: '90vh',
        borderRadius: '20px 20px 0px 0px',
        margin: '0px -30px ',
        padding: '0px 50px 0px 50px',
        width: '117%',
        fontColor: '#FDFCFF ! important',
      }}
    >
      <div style={{}}>
        <GridContainer
          style={{
            borderRadius: '20px 20px 20px 20px',
            padding: '10px 0px 20px 0px',
          }}
        >
          <GridItem xs={6}>
            <h3
              style={{
                margin: '25px 0px -11px 20px',
                fontFamily: 'Raleway',
                fontSize: '18px',
                color: '#A683FC',
                fontWeight: '600',
              }}
            >
              Account
            </h3>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ padding: '10px 0px 20px 0px' }}>
          <GridItem xs={2}>
            <PersonOutlineIcon
              style={{ margin: '0px 0px0 0px 0px', color: '#E6E6E6' }}
            />
            <SettingsOutlinedIcon
              style={{ margin: '0px 0px0 0px 0px', color: '#E6E6E6' }}
            />
            <LockOutlinedIcon
              style={{ margin: '0px 0px0 0px 0px', color: '#E6E6E6' }}
            />
          </GridItem>
          <GridItem xs={7}>
            <h4
              style={{
                margin: '0px 0px 0px -14px',
                fontSize: '18px',
                fontFamily: 'Raleway',
                color: '#171055',
                fontWeight: '600',
              }}
            >
              Edit profile
            </h4>
            <h5
              style={{
                margin: '5px -6px 0px -14px',
                fontSize: '18px',
                fontFamily: 'Raleway',
                color: '#171055',
                fontWeight: '600',
              }}
            >
              Account Settings
            </h5>
            <h4
              style={{
                margin: '5px 0px -5px -14px',
                fontSize: '18px',
                fontFamily: 'Raleway',
                color: '#171055',
                fontWeight: '600',
              }}
            >
              Remove Ads
            </h4>
          </GridItem>
        </GridContainer>

        {/* Your Music Imprint page  */}
        <GridContainer style={{ margin: '0px 0px 0px 30px' }}>
          <GridItem xs={12}>
            <h4
              style={{
                margin: '0px 0px 0px -30px',
                fontSize: '18px',
                fontFamily: 'Raleway',
                color: '#A683FC',
                fontWeight: '600',
              }}
            >
              Your Music Imprint
            </h4>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ padding: '10px 0px 20px 0px' }}>
          <GridItem xs={2}>
            <BarChartOutlinedIcon
              style={{ margin: '0px 0px0 0px 0px', color: '#E6E6E6' }}
            />
            <DashboardOutlinedIcon
              style={{ margin: '0px 0px0 0px 0px', color: '#E6E6E6' }}
            />
          </GridItem>
          <GridItem xs={8}>
            <h1
              style={{
                margin: '4px -6px 0px -15px',
                fontSize: '17px',
                fontFamily: 'Raleway',
                color: '#171055',
                fontWeight: '600',
              }}
              onClick={() => history.push({ pathname: '/pick-genres', nextPage: '/settings' })}
            >
              Manage Genre Interests
            </h1>
            <h4
              style={{
                margin: '5px -14px 0px -13px',
                fontSize: '17px',
                fontFamily: 'Raleway',
                color: '#171055',
                fontWeight: '600',
              }}
              onClick={() => history.push('/profile')}
            >
              Edit Your Imprint
            </h4>
          </GridItem>
        </GridContainer>
        {/* Notifications Page */}
        <GridContainer style={{ margin: '0px 0px 0px 30px' }}>
          <GridItem xs={12}>
            <h4
              style={{
                margin: '0px 0px 0px -30px',
                fontSize: '18px',
                fontFamily: 'Raleway',
                color: '#A683FC',
                fontWeight: '600',
              }}
            >
              General
            </h4>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ padding: '10px 0px 20px 0px' }}>
          <GridItem xs={2}>
            <NotificationsNoneOutlinedIcon
              style={{ margin: '0px 0px0 0px 0px', color: '#E6E6E6' }}
            />
          </GridItem>
          <GridItem xs={8}>
            <h1
              style={{
                margin: '4px -6px 0px -15px',
                fontSize: '17px',
                fontFamily: 'Raleway',
                color: '#171055',
                fontWeight: '600',
              }}
            >
              Notifications
            </h1>
          </GridItem>
        </GridContainer>

        {/* About */}

        <GridContainer>
          <GridItem xs={12}>
            <h4
              style={{
                margin: '0px 0px 0px 15px',
                fontSize: '18px',
                fontFamily: 'Raleway',
                color: '#A683FC',
                fontWeight: '600',
              }}
            >
              About
            </h4>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ padding: '10px 0px 20px 0px' }}>
          <GridItem xs={2}>
            <TurnedInNotIcon
              style={{ margin: '0px 0px0 0px 0px', color: '#E6E6E6' }}
            />
          </GridItem>
          <GridItem xs={8}>
            <h1
              style={{
                margin: '4px -6px 0px -15px',
                fontSize: '17px',
                fontFamily: 'Raleway',
                color: '#171055',
                fontWeight: '600',
              }}
            >
              Privacy Policy
            </h1>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={2}>
            <ExitToAppOutlinedIcon
              style={{ margin: '0px 0px0 0px 0px', color: '#E6E6E6' }}
            />
          </GridItem>
          <GridItem xs={8}>
            <h1
              onClick={signout}
              style={{
                margin: '4px -6px 0px -15px',
                fontSize: '17px',
                fontFamily: 'Raleway',
                color: '#171055',
                fontWeight: '600',
              }}
            >
              Log Out
            </h1>
          </GridItem>
        </GridContainer>
      </div>
    </Card>
  );
};

export default connect(
  null,
  { logout }
)(Settings);
